import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
import { jsx as e } from "react/jsx-runtime";
import { calculateRem as i } from "@vds-core/utilities";
import { ColorTokens as r } from "@vds-tokens/color";
import t from "styled-components";
var o = i("10px"),
  n = r.elements.primary.onlight.value,
  d = r.elements.primary.ondark.value,
  a = r.interactive.disabled.onlight.value,
  s = r.interactive.disabled.ondark.value,
  l = {
    disabled: !1,
    height: 20,
    width: 20,
    surface: "light"
  },
  c = t.div.withConfig({
    displayName: "StyledWrapper",
    componentId: "VDS__sc-13khj4n-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n"]))),
  u = t.div.withConfig({
    displayName: "StyledOuterCircle",
    componentId: "VDS__sc-13khj4n-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  align-items: center;\n  border-radius: 50%;\n  display: flex;\n  height: ", ";\n  justify-content: center;\n  left: ", ";\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: ", ";\n  box-sizing: border-box;\n"])), i(20), i(-20), i(20)),
  h = t.div.withConfig({
    displayName: "StyledInnerCircle",
    componentId: "VDS__sc-13khj4n-2"
  })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 50%;\n  height: ", ";\n  width: ", ";\n  position: absolute;\n\n  ", "\n"])), function (_ref) {
    var e = _ref.surface;
    return "dark" === e ? d : n;
  }, o, o, function (_ref2) {
    var e = _ref2.disabled,
      i = _ref2.surface;
    return e && "\n  background-color: ".concat("dark" === i ? s : a);
  }),
  m = function m(i) {
    var r = i.disabled,
      t = i.surface,
      o = i.selected || !1;
    return e(c, {
      children: e(u, Object.assign({}, i, {
        className: "radioOuter",
        "aria-hidden": !0,
        children: o && e(h, {
          disabled: r,
          surface: t
        })
      }))
    });
  };
m.defaultProps = l;
export { m as default };